import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const defaultState = {
  advertisers: [],
  advertiserStats: {
    country: {
      ageGroups: {},
      locEntries: [],
      qualGroups: {}
    },
    counties: []
  },
  advertOccupations: [],
  advertTotalCount: 0,
  adwatches: [],
  aggregatedAdWatches: [],
  employerSearchOccupations: [],
  offers: [],
  offerStats: [],
  statCounties: [],
  topOccupations: [],
  weeklyBids: [],
  workLocations: []
}

let state = Object.assign({}, defaultState)

const store = {
  state,
  actions,
  getters,
  mutations
}

export default store



// WEBPACK FOOTER //
// ./src/store/modules/stat/index.js